export const LIVE_KEY = 'live';

const initialState = {
  liveViewMode: null
};
const internalReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const liveReducer = (state, action) => {
  const liveState = state[LIVE_KEY] || initialState;
  const newLiveState = internalReducer(liveState, action);

  if (liveState === newLiveState) {
    return state;
  }

  return { ...state, [LIVE_KEY]: newLiveState };
};

export const getLiveState = (state) => {
  return state[LIVE_KEY] || initialState;
};

